import { useState, useEffect, useCallback } from "react";
import { getWorkflows } from "../services/workflowService";

/**
 * Custom hook for fetching the org's workflows.
 * @returns {Object} { workflows, loading, error, refresh }
 */
export const useWorkflows = () => {
  const [workflows, setWorkflows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchWorkflows = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await getWorkflows();

      if (response.success && Array.isArray(response.data)) {
        setWorkflows(response.data);
      } else {
        setError(response.message || "Failed to load workflows");
      }
    } catch (err) {
      console.error("Error loading workflows:", err);
      setError("An error occurred while loading workflows");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchWorkflows();
  }, [fetchWorkflows]);

  return { workflows, loading, error, refresh: fetchWorkflows };
};
